import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router } from 'react-router-dom';
import { ThemeProvider } from '@material-ui/styles';
import { createTheme } from '@material-ui/core/styles';

import { AuthProvider } from 'context/AuthContext';
import { SnackBarProvider } from 'context/SnackBarContext';
import { brand } from 'variables/colors';
import { montserrat } from 'variables/font';
import App from 'components/App';
import GlobalStyle from 'styles/globalStyles';

const theme = createTheme({
  palette: { primary: { main: `${brand}` } },
  typography: { fontFamily: `${montserrat}` },
});

ReactDOM.render(
  <React.StrictMode>
    <GlobalStyle />

    <SnackBarProvider>
      <AuthProvider>
        <ThemeProvider theme={theme}>
          <Router>
            <App />
          </Router>
        </ThemeProvider>
      </AuthProvider>
    </SnackBarProvider>
  </React.StrictMode>,
  document.getElementById('root'),
);
